import { playSound, Sound } from '~/assets/sounds';
import { CurrencyIcon } from '~/components/collections';
import { Button, ButtonColors, ButtonHeight } from '~/components/ui/Button';
import { Text } from '~/components/ui/Text';
import { useWalletIcon } from '~/hooks';
import { Currency, WalletType } from '~/shared';
import { StyledButtonContent, StyledContainer } from './MoneyButton.styled';

interface IMoneyButtonProps extends React.HTMLAttributes<HTMLDivElement> {
	text: string;
	icon?: string;
	walletType?: WalletType;
	onClick?: () => void;
	active?: boolean;
}

const MoneyButton: React.FC<IMoneyButtonProps> = ({
	text,
	icon,
	walletType,
	onClick,
	active,
}: IMoneyButtonProps) => {
	const rubleIcon = useWalletIcon(Currency.Ruble, true);
	const donateIcon = useWalletIcon(Currency.Donate, true);

	return (
		<StyledContainer>
			<Button
				color={active ? ButtonColors.Select2 : ButtonColors.Default}
				height={ButtonHeight.Height60}
				onClick={() => {
					onClick?.();
					playSound(Sound.ClickButton);
				}}
				onMouseEnter={() => playSound(Sound.LinkCursor)}
				style={{
					fontSize: 16,
					fontWeight: 500,
					padding: '0 20px',
				}}
			>
				<StyledButtonContent>
					<Text>{text}</Text>
					{icon ? (
						<img src={icon} />
					) : (
						<CurrencyIcon
							icon={walletType === WalletType.Donate ? donateIcon : rubleIcon}
							size="lg"
						/>
					)}
				</StyledButtonContent>
			</Button>
		</StyledContainer>
	);
};

export { MoneyButton };
